import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";

interface IAlertDialog {
  open: boolean;
  openNodes: string[];
  activateTitle: string;
  onClose: (activateSensor: boolean) => void;
}

export const AlertDialog = ({
  open,
  openNodes,
  activateTitle,
  onClose,
}: IAlertDialog) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={() => onClose(false)} fullWidth>
      <DialogContent>
        <DialogTitle>{t("Warning")}</DialogTitle>
        <Box display="flex" flexDirection="column" style={{ gap: 15 }}>
          {openNodes.map((node, index) => (
            <Box key={`node-${index}`}>{node}</Box>
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="text" color="primary" onClick={() => onClose(false)}>
          {t("Cancel")}
        </Button>
        <Button
          onClick={() => onClose(true)}
          variant="contained"
          color="primary"
        >
          {activateTitle}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
